module.exports = __webpack_public_path__ + "static/1-bigthief-ce6a5a5a78732b50c4d849004df208f7.jpg";